export const call = (prefix: string, values: Array<string>) => {
    const a = [];
    for (const value of values) {
        a.push({ id: value, name: `resources.${prefix}.${value}` });
    }
    return a;
}

export const unitTime = call("unitTime", ["minute", "hour"]);

export const status = call("status", ["draft", "enabled", "disabled"]);

export const role = call("role", ["admin", "projectManager", "teamManager", "productor"]);

export const tracking = call("tracking", ["waiting", "inProgress", "completed"]);

export const taskStatus = call("taskStatus", ["waiting", "available", "assigned", "rejected", "completed"]);